var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoneyCurrency = function SvgMoneyCurrency(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 511.997,
    height: 512,
    viewBox: "0 0 511.997 512"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5296",
    "data-name": "Group 5296",
    transform: "translate(-12163 -2308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(12163 2308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4689",
    "data-name": "Path 4689",
    d: "M97.086,234.171H9.314A7.314,7.314,0,0,1,2,226.857V51.314A7.314,7.314,0,0,1,9.314,44H97.086a7.314,7.314,0,0,1,7.314,7.314V226.857A7.314,7.314,0,0,1,97.086,234.171ZM16.629,219.543H89.771V58.629H16.629Z",
    transform: "translate(-2 263.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4690",
    "data-name": "Path 4690",
    d: "M186.311,177.472a145.8,145.8,0,0,1-33.739-3.961L14.769,140.7l3.387-14.226,137.787,32.8a131.658,131.658,0,0,0,68.023-1.968l182.923-54.857a16.6,16.6,0,0,0-6.217-32.446L258.459,82.386,257.2,67.758,399.435,55.418a31.232,31.232,0,0,1,11.7,61.03L228.214,171.306A145.655,145.655,0,0,1,186.311,177.472Z",
    transform: "translate(78.584 334.528)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4691",
    "data-name": "Path 4691",
    d: "M258.96,153.46h-51.2V138.831h51.2a21.943,21.943,0,1,0,0-43.886H237.017c-24.035,0-34.962-4.944-61.374-16.889-7.951-3.6-17.437-7.885-29.257-12.961C98.785,44.689,21.407,79.308,20.639,79.666L14.59,66.347c3.4-1.543,84.019-37.639,137.567-14.694,11.952,5.12,21.526,9.45,29.55,13.078,25.746,11.659,34.428,15.587,55.311,15.587H258.96a36.571,36.571,0,0,1,0,73.143Z",
    transform: "translate(77.48 263.455)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4692",
    "data-name": "Path 4692",
    d: "M167.657,265.314A131.657,131.657,0,1,1,299.314,133.657,131.657,131.657,0,0,1,167.657,265.314Zm0-248.686A117.029,117.029,0,1,0,284.686,133.657,117.029,117.029,0,0,0,167.657,16.629Z",
    transform: "translate(212.643 -2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5295",
    "data-name": "Group 5295",
    transform: "translate(12435.9 2339.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Value",
    d: "M90.764,72.415a49.821,49.821,0,0,1-33.47,13.517A45.991,45.991,0,0,1,15.939,60.347H59.064V52.14H12.881a42.014,42.014,0,0,1-1.448-11.1,41.252,41.252,0,0,1,1.126-9.977h46.5V23.015H15.3a45.771,45.771,0,0,1,42-26.712,48.226,48.226,0,0,1,33.47,14L98.327.969A60.193,60.193,0,0,0,57.294-15.444C31.065-15.444,9.18.487,1.456,23.015H-16.566V31.06H-.635a67.67,67.67,0,0,0-.8,9.977A49.986,49.986,0,0,0-.314,52.14H-16.566v8.207H1.939C9.824,82.553,31.226,98,56.811,98A61.193,61.193,0,0,0,98.488,80.944Z",
    transform: "translate(53.14 59.33)",
    fill: "#171926"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 102.4,
    cy: 102.4,
    r: 102.4,
    fill: "none"
  })))));
};
export default SvgMoneyCurrency;